import $ from 'jquery';
import 'bootstrap-loader';
import Cookies from 'js-cookie';
import { persistFormChanges } from './forms';

function userProfileModalWithUrl(url) {
  $('#user-modal .modal-content.main').hide();
  $('#user-modal .modal-content.loading').show();
  $('#user-modal .modal-content.main').load(url, function () {
    $('#user-modal .modal-content.loading').hide();
    $('#user-modal .modal-content.main').show();
  });
  $('#user-modal').modal();
}

function userProfileModal(id, participation_pk = null) {
  var url = '/accounts/' + id + '/';

  let params = {};
  if (participation_pk) {
    params.participation_pk = participation_pk;
  }
  var query = Object.keys(params)
    .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
    .join('&');

  url = url + '?' + query;

  $('#user-modal .modal-content.main').hide();
  $('#user-modal .modal-content.loading').show();
  $('#user-modal .modal-content.main').load(url, function () {
    $('#user-modal .modal-content.loading').hide();
    $('#user-modal .modal-content.main').show();
  });
  $('#user-modal').modal();
}

/**
 * Shows a bootstrap style banner on top of the screen.
 * @param message
 * @param alertType: "danger"|"info"|"warning"|"success"
 * @param timeOut: number
 * @param position: "bottom-right" | null
 */
function showAlert(message, alertType = 'danger', timeOut = 5000, position = null) {
  const uuid = Math.random().toString(36).slice(-6);
  const id = 'generic-alert-' + uuid;
  const positionClass = position ? `generic-alert-${position}` : '';
  $('body').append(
    '<div id="' +
      id +
      '" class="generic-alert ' +
      positionClass +
      '">' +
      '<div class="alert alert-' +
      alertType +
      '">' +
      '<a class="close" data-dismiss="alert">×</a>' +
      '<span>' +
      message +
      '</span>' +
      '</div>' +
      '</div>'
  );

  $('#' + id).slideDown();

  setTimeout(function () {
    // this will automatically close the alert and remove this if the users doesnt close it in 5 secs
    const $banner = $('#' + id);
    $banner.slideUp(function () {
      $banner.remove();
    });
  }, timeOut);
}

/**
 * Static modal can only be closed by clicking on the close button
 * @param id
 */
function showStaticModal(id) {
  $('#' + id).modal({ backdrop: 'static', keyboard: false }, 'show');
}

function showModal(id) {
  $('#' + id).modal();
}

function hideModal(id) {
  $('#' + id).modal('hide');
}

function buttonLoading({ isLoading, button, spinner = true }) {
  if (!button) return;
  if (isLoading) {
    button.prop('disabled', true);
    button.find('.icon-spinner').remove();
    button.toggleClass('btn-loading', true);
    if (spinner) button.prepend('<span class="icon icon-spinner animate-spin"></span>');
  } else {
    button.prop('disabled', false);
    button.toggleClass('btn-loading', false);
    button.find('.icon-spinner').remove();
  }
}

function initModalForm(modal_id, success_callback, hide_modal = true, button_loading_animation = false) {
  const modal_div = $(`#${modal_id}`);
  const $form = $('form', modal_div);
  const save_button = $('.save', $form);
  const genericErrorMessage =
    '<div class="unknown-error alert alert-danger">Error while submitting the form. Please try again.</div>';

  // onSubmit listener
  $form.off('submit').on('submit', function (e) {
    e.preventDefault();

    const data = $form.serialize();
    $('.help-block.auto-error', $form).remove();

    // Disable save button and all inputs while loading
    if (button_loading_animation) {
      buttonLoading({ isLoading: true, button: save_button });
    } else {
      save_button.prop('disabled', true);
    }
    $('input, textarea, select', $form).prop('disabled', true);
    $('.unknown-error', $form).remove();

    $.ajax({
      url: $form.attr('action'),
      method: $form.attr('method'),
      headers: { 'X-CSRFToken': Cookies.get('csrftoken') },
      data: data,
      success: (data, textStatus, jqXHR) => {
        // SUCCESS: Remove all error classes
        for (var el of $form[0].querySelectorAll('.has-error')) {
          el.classList.remove('has-error');
        }
        // Call callback if defined
        if (success_callback) {
          success_callback(data);
        }
        // Dismiss modal
        if (hide_modal) {
          modal_div.modal('hide');
        }
      },
      error: (jqXHR, textStatus, errorThrown) => {
        // Highlight errors: add error-class to the inputs (form-group parent)
        let errorCount = 0;
        const response = jqXHR.responseJSON || {};

        Object.keys(response).forEach((key) => {
          const input = $form[0].querySelector(`[name="${key}"]`);
          if (input) {
            input.parentNode.classList.add('has-error');
            errorCount += 1;
            // Remove any previous error messages
            input.parentNode.querySelectorAll('.auto-error').forEach((el) => el.remove());

            const errorText = jqXHR.responseJSON[key];
            if (errorText) {
              $(
                `<div class="help-block with-errors auto-error"><ul class="list-unstyled"><li>${errorText}</li></ul></div>`
              ).insertAfter(input);
            }
          }
        });
        if (errorCount === 0) {
          save_button.before(genericErrorMessage);
        }
      },
      complete: (jqXHR, testStatus) => {
        // Re-enable save button and all inputs
        if (button_loading_animation) {
          buttonLoading({ isLoading: false, button: save_button });
        } else {
          save_button.prop('disabled', false);
        }
        $('input, textarea, select', $form).prop('disabled', false);
      }
    });
  });
}

function setUpBillingAddressModal(callback, skipSuccessUpdate) {
  initModalForm('billing-address-modal', function (data) {
    if (!skipSuccessUpdate) {
      if (data.company_name) {
        document.getElementById('name').textContent = data.company_name;
      } else {
        document.getElementById('name').textContent = [data.first_name, data.last_name].join(' ');
      }
      if (data.vat_number) {
        document.getElementById('vat_number').textContent = data.vat_number;
      } else {
        document.getElementById('vat_number').textContent = data.vat_number;
      }
      document.getElementById('address').textContent = data.address;
      document.getElementById('city').textContent = data.city;
      document.getElementById('zip').textContent = data.zip;

      const option = document.querySelector('option[value=' + data.country + ']'); // hack
      document.getElementById('country').textContent = option ? option.textContent : '-';

      document.getElementById('panel-no-billing-address').style.display = 'none';
      document.getElementById('panel-billing-address').style.display = '';
    }

    if (callback) {
      callback(data);
    }
  });

  for (var edit_link of document.querySelectorAll('.editmodal')) {
    edit_link.addEventListener('click', (event) => {
      event.preventDefault();
      showStaticModal('billing-address-modal');
      return false;
    });
  }
}

function setupPaymentDetailsModal(hasBillingAddress, persistFormName) {
  $(document).on('click', '.paymentDetailsModal', (event) => {
    event.preventDefault();

    if (persistFormName) {
      persistFormChanges(persistFormName);
    }

    if (hasBillingAddress) {
      showStaticModal('payment-details-modal');
    } else {
      setUpBillingAddressModal(() => {
        showStaticModal('payment-details-modal');
      }, true);
      showStaticModal('billing-address-modal');
    }
  });
}

function setUpTrialActivationModal() {
  const currentDate = new Date();
  const trialEndDate = currentDate.setDate(currentDate.getDate() + 15);
  const trialEndFromatted = new Date(trialEndDate).toLocaleString('en-US', { month: 'short', day: 'numeric' });

  $(document).on('click', '.trailActivationModal', (event) => {
    event.preventDefault();
    showModal('trial-activation-modal');
  });

  $(document).on('click', '#activateTrial', (event) => {
    const setModalLoadingState = (isLoading) => {
      event.target.disabled = isLoading;
      event.target.textContent = isLoading ? 'Loading...' : 'Get free trial';
    };

    setModalLoadingState(true);

    $.ajax({
      type: 'POST',
      url: '/engage/api/billing/start_trial/',
      headers: { 'X-CSRFToken': Cookies.get('csrftoken') },
      success: () => {
        setModalLoadingState(false);
        $('.modal').modal('hide');
        showModal('trial-activation-success-modal');
        document.getElementById('trialEndDate').textContent = trialEndFromatted;
      },
      error: () => {
        setModalLoadingState(false);
        showAlert('There was a problem starting your trial. Please try again later.', 'danger', 5000, 'bottom-right');
      }
    });
  });
}

function setUpBasicModal(open_selector, modal_selector, form_selector) {
  $(document).on('click', open_selector, function (e) {
    $(modal_selector).html($('#modal-loading').html());
    $(modal_selector).modal();
    $.ajax({
      type: 'GET',
      url: $(event.target).data('form-url'),
      success: function (data) {
        $(modal_selector).html(data);
      }
    });

    return false;
  });

  $(document).on('submit', form_selector, function (event) {
    event.preventDefault();
    $.ajax({
      type: 'POST',
      url: $(event.target).attr('action'),
      data: $(event.target).serialize(),
      success: function (data) {
        $(modal_selector).html(data);
      }
    });
    return false;
  });
}

export {
  userProfileModal,
  showStaticModal,
  showModal,
  initModalForm,
  buttonLoading,
  setUpBillingAddressModal,
  setUpBasicModal,
  userProfileModalWithUrl,
  showAlert,
  setUpTrialActivationModal,
  setupPaymentDetailsModal
};
